import React from "react";
import { useLanguage } from "../LanguageContext";

export default function Pricing() {
    const { lang } = useLanguage();

    const BASE_URL =
        process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, "") ||
        "http://localhost:8000";

    return (
        <div style={{ padding: "100px 20px", textAlign: "center" }}>

            {/* HERO */}
            <h1>
                {lang === "sr" ? "Jednostavna pretplata" :
                    lang === "de" ? "Einfaches Abonnement" :
                        "Simple Subscription"}
            </h1>

            <p style={{ maxWidth: "600px", margin: "0 auto" }}>
                {lang === "sr"
                    ? "FunlishLand koristi mesečnu pretplatu za pristup svim lekcijama."
                    : lang === "de"
                        ? "FunlishLand verwendet ein monatliches Abonnement für den Zugriff auf alle Lektionen."
                        : "FunlishLand uses a monthly subscription to unlock all lessons."}
            </p>

            {/* MAIN CARD */}
            <div style={{
                marginTop: "40px",
                padding: "30px",
                border: "1px solid #ddd",
                borderRadius: "12px",
                maxWidth: "400px",
                marginInline: "auto"
            }}>
                <h2>€4 / {lang === "sr" ? "mesečno" : lang === "de" ? "Monat" : "month"}</h2>

                <ul style={{ textAlign: "left", marginTop: "20px" }}>
                    <li>✔ {
                        lang === "sr" ? "Sve lekcije dostupne" :
                            lang === "de" ? "Alle Lektionen verfügbar" :
                                "All lessons unlocked"
                    }</li>

                    <li>✔ {
                        lang === "sr" ? "Nove lekcije redovno" :
                            lang === "de" ? "Neue Lektionen regelmäßig" :
                                "New lessons regularly"
                    }</li>
                </ul>

                {/* IMPORTANT BUTTON */}
                <a
                    href={`${ BASE_URL }/pricing/?lang=${ lang }`}
                    style={{
                        display: "inline-block",
                        marginTop: "20px",
                        padding: "10px 20px",
                        background: "#007bff",
                        color: "#fff",
                        borderRadius: "6px",
                        textDecoration: "none"
                    }}
                >
                    {lang === "sr" ? "Idi na sajt za pretplatu" :
                        lang === "de" ? "Zur Website gehen" :
                            "Go to main site to subscribe"}
                </a>
            </div>

            {/* FREE SECTION */}
            <div style={{ marginTop: "50px" }}>


                <p>
                    {lang === "sr"
                        ? "Možete igrati igre i koristiti kvizove bez registracije."
                        : lang === "de"
                            ? "Spiele und Quizze sind ohne Registrierung verfügbar."
                            : "You can play games and use quizzes without registration."}
                </p>

                <p>
                    {lang === "sr"
                        ? "Za pristup lekcijama potrebno je kreirati nalog na glavnom sajtu."
                        : lang === "de"
                            ? "Für Lektionen ist eine Registrierung auf der Hauptseite erforderlich."
                            : "To access lessons, you need to create an account on the main website."}
                </p>
            </div>
        </div>
    );
}